import { memo, useMemo } from 'react';
import { RendererProviderStore } from '../../../redux/rendererReducer';
import { T } from '../../../translation/src';
import { PropertiesSection, Property } from './PropertiesSection';
import { useFlatAnnotationList } from '../../../hooks/potree/useFlatAnnotationList';
import { PropertyPanel } from '../../Properties/components/PropertyPanel';
import { TypeFilterButton, useTypeFilter } from './typeFilter';

interface MultiSelectPropertiesProps {
  projectId: string;
  selection: RendererProviderStore['selectedAnnotations'];
}
const MultiSelectProperties_: React.FC2<MultiSelectPropertiesProps> = ({ projectId, selection }) => {
  const { allSelectedAnnotations } = useFlatAnnotationList();

  const selectedGroups = useMemo(() => selection.filter((s) => s.type === 'group'), [selection]);

  const { availableKeys, selectedKeys, toggleKey, visibleIdentifiers, visibleTypes, visibleAnnotations, isGroupView } = useTypeFilter(allSelectedAnnotations);

  return (
    <div className="flex flex-col space-y-4 divide-y divide-gray-800">
      <PropertiesSection title={<T _str="information" swc />}>
        <Property title={<T _str="type" swc />}>
          <T _str="selection" swc />
        </Property>
        <Property title={<T _str="objects" swc />}>{new Set(allSelectedAnnotations).size}</Property>
        <Property title={<T _str="groups" swc />}>{selectedGroups.length}</Property>
      </PropertiesSection>
      <PropertyPanel
        projectId={projectId}
        annotationTypes={visibleTypes}
        objectIdentifiers={visibleIdentifiers}
        selectedAnnotations={visibleAnnotations}
        isGroupView={isGroupView}
        headerAction={availableKeys.length > 1 ? <TypeFilterButton availableKeys={availableKeys} selectedKeys={selectedKeys} toggleKey={toggleKey} /> : undefined}
      />
    </div>
  );
};

export const MultiSelectProperties = memo(MultiSelectProperties_);
